<p [ngStyle]="{ width: (isHost$ | async) ? 'auto' : '100%', 'text-align': 'center' }">
  {{ "This object is locked and can't be moved." | translate }}
</p>
<div *ngIf="isHost$ | async" class="unlock" (click)="unlockAndDismiss()">
  <svg-icon [height]="13" [width]="10" icon="lock_open"></svg-icon>
  {{ 'Unlock' | translate }}
</div>
